module.exports = __webpack_public_path__ + "static/media/certificate.ef2992a7.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Certificate/certificate.pdf
// module id = 431
// module chunks = 0